import { render } from "./PaymentFailedView.vue?vue&type=template&id=7bd42573&ts=true"
import script from "./PaymentFailedView.vue?vue&type=script&lang=ts"
export * from "./PaymentFailedView.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__